// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"5XMEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _common = require("./common");
var _app = require("firebase/compat/app");
var _appDefault = parcelHelpers.interopDefault(_app);
var _auth = require("firebase/compat/auth");
var _storage = require("firebase/compat/storage");
var userProfile;
var trans;
var currentUserId;
var ui;
var newUser;
var authListener;
var email;
var registerUser;
$(document).ready(function() {
    $(function() {
        initViews();
        translatePage();
        initClickListeners();
        (0, _common.reformatPaste)();
        userProfile = {
            userId: null,
            email: null,
            profile_Image: null,
            name: null,
            lowCaseName: null,
            isCreator: true,
            date_created: null
        };
        getUser();
        window.onclick = function(event) {
            if (!event.target.matches(".dropbtn")) {
                var dropdowns = document.getElementsByClassName("dropdown-content");
                var i;
                for(i = 0; i < dropdowns.length; i++){
                    var openDropdown = dropdowns[i];
                    if (openDropdown.classList.contains("show")) openDropdown.classList.remove("show");
                }
            }
        };
        (0, _common.checkDevice)();
    });
});
function initViews() {
    (0, _common.initCommonViews)();
    registerUser = document.getElementById("registerUser");
}
function initClickListeners() {
    btnTranslate.addEventListener("click", function() {
        showDropdown();
    });
    aEn.addEventListener("click", function() {
        translatePage("en");
    });
    aEs.addEventListener("click", function() {
        translatePage("es");
    });
    downloadApp.querySelector(".close").addEventListener("click", function() {
        (0, _common.closeModal)("downloadApp");
    });
    registerModal.querySelector(".img-thumbnail").addEventListener("click", function() {
        uploadImage("register");
    });
    myModal.querySelector(".close").addEventListener("click", function() {
        (0, _common.closeMyModal)();
    });
    myModal.querySelector(".btnBlue").addEventListener("click", function() {
        (0, _common.closeMyModal)();
    });
    fufuf.addEventListener("click", function() {
        uploadImage("banner");
    });
    upLogo.addEventListener("click", function() {
        uploadImage("logo");
    });
    inRadioStream.addEventListener("input", function() {
        editAudio.innerHTML = "";
        var radioUrl = inRadioStream.value.trim();
        var source = document.createElement("source"); //document.getElementById('radioStream');
        source.src = radioUrl;
        editAudio.appendChild(source);
        var backupSource = document.createElement("source");
        var backUpUrl;
        if (radioUrl.endsWith("/")) backUpUrl = radioUrl + ";";
        else if (radioUrl.endsWith("/;")) //backupSource.src = radioStream;
        backUpUrl = radioUrl;
        else //backupSource.src = radioStream + "/;";
        backUpUrl = inRadioStream.value.trim() + "/;";
        backupSource.src = backUpUrl;
        editAudio.appendChild(backupSource);
        editAudio.load();
        var note = registerRadio.querySelector(".notes.redText");
        note.style.display = radioUrl.includes("https") ? "none" : "block";
        aRadioLink.href = radioUrl;
    });
}
function showDropdown() {
    document.getElementById("langDropdown").classList.toggle("show");
}
function getUser() {
    authListener = (0, _appDefault.default).auth().onAuthStateChanged(function(user) {
        if (user) {
            currentUserId = (0, _appDefault.default).auth().currentUser.uid;
            if ((0, _appDefault.default).auth().currentUser.email) email = (0, _appDefault.default).auth().currentUser.email;
            else email = (0, _appDefault.default).auth().currentUser.phoneNumber;
            getProfileInfo();
            startRadioForm();
        } else {
            //authListener();
            (0, _common.setDisplay)(registerRadio, "none");
            (0, _common.setDisplay)(registerUser, "flex");
            btnEmailLogin.addEventListener("click", function() {
                (0, _common.setDisplay)(emailOptions, "block");
                (0, _common.setDisplay)(phoneOptions, "none");
            }, false);
            btnPhoneLogin.addEventListener("click", function() {
                initPhoneOption();
                (0, _common.setDisplay)(emailOptions, "none");
                (0, _common.setDisplay)(phoneOptions, "block");
            }, false);
            btnNext.addEventListener("click", function() {
                if (etEmail.value && etEmail.value.includes("@")) {
                    (0, _common.setDisplay)(loading, "block");
                    (0, _common.setDisplay)(btnNext, "none");
                    (0, _common.setDisplay)(etPassword, "block");
                    (0, _common.setDisplay)(btnLogin, "block");
                    checkEmail(etEmail.value);
                } else {
                    (0, _common.showToast)(trans.errorEmail);
                    (0, _common.setDisplay)(loading, "none");
                }
            }, false);
            btnLogin.addEventListener("click", function() {
                if (!etPassword.value) {
                    (0, _common.showToast)(trans.errorPass);
                    return;
                }
                if (newUser) createUserEmailPass(etEmail.value, etPassword.value);
                else loginUserEmailPass(etEmail.value, etPassword.value);
            }, false);
        }
    });
}
function startRadioForm() {
    var bannerFile, logoFile;
    inBannerUpload.addEventListener("change", function() {
        if (this.files && this.files[0]) {
            bannerFile = this.files[0];
            imgBanner.src = URL.createObjectURL(bannerFile); // set src to blob url
            (0, _common.setDisplay)(imgBanner, "block");
        } else {
            bannerFile = null;
            (0, _common.setDisplay)(imgBanner, "none");
        }
    });
    inLogoUpload.addEventListener("change", function() {
        if (this.files && this.files[0]) {
            logoFile = this.files[0];
            imgLogo.src = URL.createObjectURL(logoFile); // set src to blob url
            (0, _common.setDisplay)(imgLogo, "block");
        } else {
            logoFile = null;
            (0, _common.setDisplay)(imgLogo, "none");
        }
    });
    btnAddRadio.addEventListener("click", function() {
        if (checkInput(inLogoUpload.files[0], inAdminName.value.trim(), inRadioName.value.trim(), inDescription.value.trim(), inRadioStream.value.trim(), inPassword.value.trim(), countries.value, inRadioEmail.value.trim())) {
            (0, _common.disableButton)(btnAddRadio, true);
            loadingRadioRegister.querySelector("p").textContent = trans.radioRegister;
            (0, _common.setDisplay)(loadingRadioRegister, "block");
            checkStream(inRadioStream.value.trim(), bannerFile, logoFile);
        }
    }, false);
}
function checkStream(radioStream, bannerFile, logoFile) {
    var radiosRef = (0, _appDefault.default).database().ref("Radio Stations");
    radiosRef.orderByChild("info/radio_Stream").equalTo(radioStream).once("value", function(snapshot) {
        if (snapshot.exists()) {
            (0, _common.disableButton)(btnAddRadio, false);
            (0, _common.setDisplay)(loadingRadioRegister, "none");
            (0, _common.setModalMessage)(trans.errorStreamCopy);
            (0, _common.openCommonModal)();
        } else //check name exists
        checkRadioName(radioStream, bannerFile, logoFile);
    });
}
function checkRadioName(radioStream, bannerFile, logoFile) {
    var radiosRef = (0, _appDefault.default).database().ref("Radio Stations");
    var radioName = inRadioName.value.trim();
    radiosRef.orderByChild("info/radio_Name").equalTo(radioName).once("value", function(snapshot) {
        if (snapshot.exists()) {
            (0, _common.disableButton)(btnAddRadio, false);
            (0, _common.setDisplay)(loadingRadioRegister, "none");
            (0, _common.setModalMessage)(trans.errorNameCopy);
            (0, _common.openCommonModal)();
        } else //check name exists
        createRadio(radioStream, radiosRef, bannerFile, logoFile);
    });
}
function createRadio(radioStream, radiosRef, bannerFile, logoFile) {
    var radioId = radiosRef.push().key;
    if (radioId) uploadLogo(radioId, bannerFile, logoFile, radioStream);
    else {
        (0, _common.disableButton)(btnAddRadio, false);
        (0, _common.setDisplay)(loadingRadioRegister, "none");
        (0, _common.setModalMessage)(trans.errorUnknown);
        (0, _common.openCommonModal)();
    }
}
function uploadLogo(radioId, bannerFile, logoFile, radioStream) {
    //Upload logo
    var logoPath = "Radio Stations/" + radioId + "/Logo";
    var storageRef = (0, _appDefault.default).storage().ref().child(logoPath);
    var uploadTask = storageRef.put(logoFile);
    uploadTask.on("state_changed", function(snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        if (progress) loadingRadioRegister.querySelector("p").textContent = trans.uploadingLogo + progress + "%";
    //console.log('Upload is ' + progress + '% done');
    }, function(error) {
        var errorMess;
        switch(error.code){
            case "storage/unauthorized":
                // User doesn't have permission to access the object
                errorMess = trans.errorImage;
                break;
            case "storage/canceled":
                errorMess = trans.errorUploadCancel;
                break;
            case "storage/unknown":
                // Unknown error occurred, inspect error.serverResponse
                errorMess = trans.errorUnknown;
                break;
        }
        (0, _common.disableButton)(btnAddRadio, false);
        (0, _common.setDisplay)(loadingRadioRegister, "none");
        (0, _common.setModalMessage)(errorMess);
        (0, _common.openCommonModal)();
    }, function() {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            //console.log('File available at', downloadURL);
            //Upload banner if available
            if (bannerFile) uploadBanner(radioId, downloadURL, bannerFile, radioStream);
            else uploadRadioInfo(radioId, downloadURL, null, radioStream);
        });
    });
}
function uploadBanner(radioId, logoUrl, bannerFile, radioStream) {
    //Upload banner
    var bannerPath = "Radio Stations/" + radioId + "/Banner";
    var storageRef = (0, _appDefault.default).storage().ref().child(bannerPath);
    var uploadTask = storageRef.put(bannerFile);
    uploadTask.on("state_changed", function(snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        if (progress) loadingRadioRegister.querySelector("p").textContent = trans.uploadingBanner + progress + "%";
    //console.log('Upload is ' + progress + '% done');
    }, function(error) {
        var errorMess;
        switch(error.code){
            case "storage/unauthorized":
                // User doesn't have permission to access the object
                errorMess = trans.errorImage;
                break;
            case "storage/canceled":
                errorMess = trans.errorUploadCancel;
                break;
            case "storage/unknown":
                // Unknown error occurred, inspect error.serverResponse
                errorMess = trans.errorUnknown;
                break;
        }
        (0, _common.disableButton)(btnAddRadio, false);
        (0, _common.setDisplay)(loadingRadioRegister, "none");
        (0, _common.setModalMessage)(errorMess);
        (0, _common.openCommonModal)();
    }, function() {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            //console.log('File available at', downloadURL);
            uploadRadioInfo(radioId, logoUrl, downloadURL, radioStream);
        });
    });
}
function uploadRadioInfo(radioId, logoUrl, bannerUrl, radioStream) {
    var radName = inRadioName.value.trim();
    loadingRadioRegister.querySelector("p").textContent = trans.uploadingRadioInfo;
    var time = new Date().getTime();
    var radioInfo = {
        radio_Name: radName,
        radio_Slogan: null,
        radio_image: logoUrl,
        banner: null,
        date_created: time,
        radio_ID: radioId,
        verified: false
    };
    var newRadio = {
        admin_ID: currentUserId,
        admin_Name: inAdminName.value.trim(),
        lowCaseName: radName.toLowerCase(),
        admin_Pass: inPassword.value.trim(),
        radio_Name: radName,
        radio_Description: inDescription.value.trim(),
        radio_Stream: radioStream,
        radio_location: countries.options[countries.selectedIndex].textContent,
        radio_Slogan: null,
        phone_no: null,
        radio_email: null,
        website: null,
        radio_image: logoUrl,
        banner: null,
        date_created: time
    };
    if (bannerUrl) {
        radioInfo.banner = bannerUrl;
        newRadio.banner = bannerUrl;
    }
    if (inSlogan.value.trim()) {
        radioInfo.radio_Slogan = inSlogan.value.trim();
        newRadio.radio_Slogan = inSlogan.value.trim();
    }
    if (inPhone.value.trim()) newRadio.phone_no = inPhone.value.trim();
    if (inRadioEmail.value.trim()) newRadio.radio_email = inRadioEmail.value.trim();
    if (inWebsite.value.trim()) newRadio.website = inWebsite.value.trim();
    //Upload to verify radio
    var radiosRef = (0, _appDefault.default).database().ref("verify/radio/" + radioId + "/info");
    radiosRef.set(newRadio, function(error) {
        if (error) {
            //message failed
            (0, _common.disableButton)(btnAddRadio, false);
            (0, _common.setDisplay)(loadingRadioRegister, "none");
            (0, _common.setModalMessage)(trans.errorUnknown);
            (0, _common.openCommonModal)();
        } else {
            //Upload radioInfo
            loadingRadioRegister.querySelector("p").textContent = trans.radioRegister;
            var userRadiosRef = (0, _appDefault.default).database().ref("Users/" + currentUserId + "/My_Radios/" + radioId);
            userRadiosRef.set(radioInfo, function(error) {
                if (error) {
                    //message failed
                    (0, _common.disableButton)(btnAddRadio, false);
                    (0, _common.setDisplay)(loadingRadioRegister, "none");
                    (0, _common.setModalMessage)(trans.errorUnknown);
                    (0, _common.openCommonModal)();
                } else {
                    //Upload userProfile
                    loadingRadioRegister.querySelector("p").textContent = trans.uploadingRadioInfo;
                    userProfile.date_created = time;
                    var adminRadioRef = (0, _appDefault.default).database().ref("verify/radio/" + radioId + "/Administrators/" + currentUserId);
                    adminRadioRef.set(userProfile, function(error) {
                        if (error) {
                            //message failed
                            (0, _common.disableButton)(btnAddRadio, false);
                            (0, _common.setDisplay)(loadingRadioRegister, "none");
                            (0, _common.setModalMessage)(trans.errorUnknown);
                            (0, _common.openCommonModal)();
                        } else {
                            //show completion message
                            (0, _common.disableButton)(btnAddRadio, false);
                            (0, _common.setDisplay)(loadingRadioRegister, "none");
                            //registerRadio.querySelector('form').reset();
                            modRegSuccess.querySelector("h2").textContent = trans.congrats;
                            modRegSuccess.querySelector("p").innerHTML = trans.msgRadioVerify.replace("$name", radName);
                            // var rad = radName.replace(/--/g, "_");
                            // rad = rad.replace(/\s+/g, "-");
                            // rad = rad.replace(/_/g,"--");
                            var urlExt = modRegSuccess.querySelector("a").href + "$v=" + radioId;
                            modRegSuccess.querySelector("a").href = urlExt;
                            modRegSuccess.querySelector("a").textContent = urlExt;
                            btnContinue.addEventListener("click", function() {
                                goToRadioWeb(urlExt);
                            }, false);
                            (0, _common.setDisplay)(modRegSuccess, "flex");
                        }
                    });
                }
            });
        }
    });
//Upload to Radio Stations
// var radiosRef = firebase.database().ref("Radio Stations/" + radioId + "/info");
// radiosRef.set(newRadio,
// function(error){
//     if(error)
//     {
//         //message failed
//         disableButton(btnAddRadio, false);
//         setDisplay(loadingRadioRegister,"none");
//         setModalMessage(trans.errorUnknown);
//         openCommonModal();
//     }
//     else{
//         //Upload radioInfo
//         loadingRadioRegister.querySelector('p').textContent = trans.radioRegister;
//         var userRadiosRef = firebase.database().ref("Users/"+ currentUserId + "/My_Radios/" + radioId);
//         userRadiosRef.set(radioInfo,
//         function(error){
//             if(error)
//             {
//                 //message failed
//                 disableButton(btnAddRadio, false);
//                 setDisplay(loadingRadioRegister,"none");
//                 setModalMessage(trans.errorUnknown);
//                 openCommonModal();
//             }
//             else{
//                 //Upload userProfile
//                 loadingRadioRegister.querySelector('p').textContent = trans.uploadingRadioInfo;
//                 userProfile.date_created = time;
//                 var adminRadioRef = firebase.database().ref("Radio Stations/"+ radioId + "/Administrators/" + currentUserId);
//                 adminRadioRef.set(userProfile,
//                 function(error){
//                     if(error)
//                     {
//                         //message failed
//                         disableButton(btnAddRadio, false);
//                         setDisplay(loadingRadioRegister,"none");
//                         setModalMessage(trans.errorUnknown);
//                         openCommonModal();
//                     }
//                     else{
//                         //show completion message
//                         disableButton(btnAddRadio, false);
//                         setDisplay(loadingRadioRegister,"none");
//                         //registerRadio.querySelector('form').reset();
//                         modRegSuccess.querySelector('h2').textContent = trans.congrats;
//                         modRegSuccess.querySelector('p').innerHTML = trans.radioMessage;
//                         var rad = radName.replace(/--/g, "_");
//                         rad = rad.replace(/\s+/g, "-");
//                         rad = rad.replace(/_/g,"--");
//                         var urlExt = modRegSuccess.querySelector('a').href + rad;//radName.replace(/--/g, "_").replace(/\s+/g, "-").replace(/_/g,"--");
//                         modRegSuccess.querySelector('a').href =  urlExt;
//                         modRegSuccess.querySelector('a').textContent = urlExt;
//                         btnContinue.addEventListener('click', function(){
//                             goToRadioWeb(urlExt);
//                         },false);
//                         setDisplay(modRegSuccess,"flex");
//                     }
//                 });
//             }
//         });
//     }
// });
}
function goToRadioWeb(radioUrl) {
    window.location.replace(radioUrl);
}
function checkInput(logo, adminName, radioName, radioDesc, radioUrl, adminPass, radioLocation, radioEmail) {
    if (!logo) {
        (0, _common.showToast)(trans.errorLogo);
        var topOfElement = document.querySelector("#upLogo").offsetTop - 62;
        window.scroll({
            top: topOfElement,
            behavior: "smooth"
        });
        $(upLogo).shake();
        return false;
    } else if (!adminName) {
        (0, _common.showToast)(trans.errorName);
        var topOfElement = document.querySelector("#inAdminName").offsetTop - 62;
        window.scroll({
            top: topOfElement,
            behavior: "smooth"
        });
        $(inAdminName).shake();
        return false;
    } else if (!radioName) {
        (0, _common.showToast)(trans.errorRadioName);
        //inRadioName.scrollIntoView();
        var topOfElement = document.querySelector("#inRadioName").offsetTop - 62;
        window.scroll({
            top: topOfElement,
            behavior: "smooth"
        });
        $(inRadioName).shake();
        return false;
    } else if (!radioEmail || !radioEmail.includes("@")) {
        (0, _common.showToast)(trans.errorEmail);
        var topOfElement = document.querySelector("#inRadioEmail").offsetTop - 62;
        window.scroll({
            top: topOfElement,
            behavior: "smooth"
        });
        $(inRadioEmail).shake();
        return false;
    } else if (!radioUrl || !inRadioStream.checkValidity()) {
        (0, _common.showToast)(trans.errorRadioUrl);
        var topOfElement = document.querySelector("#inRadioStream").offsetTop - 62;
        window.scroll({
            top: topOfElement,
            behavior: "smooth"
        });
        $(inRadioStream).shake();
        return false;
    } else if (!adminPass) {
        (0, _common.showToast)(trans.errorAdminpass);
        var topOfElement = document.querySelector("#inPassword").offsetTop - 62;
        window.scroll({
            top: topOfElement,
            behavior: "smooth"
        });
        $(inPassword).shake();
        return false;
    } else if (!radioDesc) {
        (0, _common.showToast)(trans.errorDescription);
        var topOfElement = document.querySelector("#inDescription").offsetTop - 62;
        window.scroll({
            top: topOfElement,
            behavior: "smooth"
        });
        $(inDescription).shake();
        return false;
    } else if (!radioLocation) {
        (0, _common.showToast)(trans.errorLocation);
        var topOfElement = document.querySelector("#countries").offsetTop - 62;
        window.scroll({
            top: topOfElement,
            behavior: "smooth"
        });
        $(countries).shake();
        return false;
    } else return true;
}
function createUserEmailPass(email, pass) {
    (0, _common.setDisplay)(loading, "block");
    (0, _appDefault.default).auth().createUserWithEmailAndPassword(email, pass).then(function(user) {
        if (user) {
            currentUserId = (0, _appDefault.default).auth().currentUser.uid;
            email = (0, _appDefault.default).auth().currentUser.email;
            (0, _common.setDisplay)(registerRadio, "block");
            (0, _common.setDisplay)(registerUser, "none");
            (0, _common.setDisplay)(loading, "none");
        //getProfileInfo();
        } else {
            (0, _common.showToast)(trans.errorRegister);
            (0, _common.setDisplay)(loading, "none");
        }
    }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        (0, _common.showToast)(errorMessage);
        (0, _common.setDisplay)(loading, "none");
    });
}
function loginUserEmailPass(email, pass) {
    (0, _common.setDisplay)(loading, "block");
    (0, _appDefault.default).auth().signInWithEmailAndPassword(email, pass).then(function() {
        currentUserId = (0, _appDefault.default).auth().currentUser.uid;
        email = (0, _appDefault.default).auth().currentUser.email;
        (0, _common.setDisplay)(registerRadio, "block");
        (0, _common.setDisplay)(registerUser, "none");
        (0, _common.setDisplay)(loading, "none");
    //getProfileInfo();
    }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        (0, _common.showToast)(errorCode + ": " + errorMessage);
        (0, _common.setDisplay)(loading, "none");
    //window.alert('Error ' + errorCode + ": " + errorMessage);
    });
}
function getProfileInfo() {
    var userRef = (0, _appDefault.default).database().ref("Users/" + currentUserId + "/info");
    userRef.once("value").then(function(snapshot) {
        if (snapshot.val()) {
            var userInfo = snapshot.val();
            userProfile.email = userInfo.email;
            userProfile.name = userInfo.name;
            userProfile.lowCaseName = userInfo.name.toLowerCase();
            if (userInfo.djImage) userProfile.profile_Image = userInfo.djImage;
            else if (userInfo.profile_Image) userProfile.profile_Image = userInfo.profile_Image;
            inAdminName.value = userProfile.name;
            (0, _common.setDisplay)(registerRadio, "block");
        } else //authListener();
        //console.log("name does not exist");
        registerUserInfo();
    });
}
function initPhoneOption() {
    if (!ui) {
        ui = new firebaseui.auth.AuthUI((0, _appDefault.default).auth());
        var uiConfig = {
            callbacks: {
                signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                    // User successfully signed in.
                    // Return type determines whether we continue the redirect automatically
                    // or whether we leave that to developer to handle.
                    currentUserId = (0, _appDefault.default).auth().currentUser.uid;
                    email = (0, _appDefault.default).auth().currentUser.phoneNumber;
                    //setDisplay(newUserModal, "none");
                    //setDisplay(loader, "none");
                    //setDisplay(petitionBox,"block");
                    //setDisplay(newUserBox,"none");
                    (0, _common.setDisplay)(loading, "none");
                    (0, _common.showToast)("Welcome!");
                    (0, _common.setDisplay)(registerRadio, "block");
                    (0, _common.setDisplay)(registerUser, "none");
                    //getCurrentUserId();
                    //getProfileInfo();
                    return false;
                },
                signInFailure: function(error) {
                    // Some unrecoverable error occurred during sign-in.
                    // Return a promise when error handling is completed and FirebaseUI
                    // will reset, clearing any UI. This commonly occurs for error code
                    // 'firebaseui/anonymous-upgrade-merge-conflict' when merge conflict
                    // occurs. Check below for more details on this.
                    (0, _common.setDisplay)(loading, "none");
                    (0, _common.showToast)(error);
                    return handleUIError(error);
                },
                uiShown: function() {
                    // The widget is rendered.
                    // Hide the loader.
                    (0, _common.setDisplay)(loading, "none");
                }
            },
            signInOptions: [
                // Leave the lines as is for the providers you want to offer your users.
                {
                    provider: (0, _appDefault.default).auth.PhoneAuthProvider.PROVIDER_ID,
                    recaptchaParameters: {
                        type: "image",
                        size: "normal",
                        badge: "bottomleft"
                    }
                }
            ],
            // Terms of service url.
            tosUrl: "https://chatmurcianys.com/about#terms",
            // Privacy policy url.
            privacyPolicyUrl: "https://chatmurcianys.com/about#privacy"
        };
        ui.start(phoneOptions, uiConfig);
    }
}
function registerUserInfo() {
    var uploadFile;
    var registerModal1 = document.getElementById("registerModal");
    var imgUser = document.getElementById("imgUser");
    imgUser.src = "../images/person_placeholder.svg";
    var inName1 = document.getElementById("inName");
    var loader = document.getElementById("loadingInfo");
    $(document).ready(function() {
        inName1.focus();
    });
    var btnRegister1 = document.getElementById("btnRegister");
    inImageUpload.addEventListener("change", function() {
        if (this.files && this.files[0]) {
            uploadFile = this.files[0];
            //console.log("image file: " + inImageUpload.value);
            // $('img')[0]
            imgUser.src = URL.createObjectURL(uploadFile); // set src to blob url
        }
    });
    (0, _common.setDisplay)(registerModal1, "block");
    btnRegister1.addEventListener("click", function() {
        if (inName1.value) {
            (0, _common.setDisplay)(loader, "block");
            (0, _common.disableButton)(btnRegister1, true);
            var userName = inName1.value;
            var time = new Date().getTime();
            var userInfo = {
                email: email,
                name: userName,
                lowCaseName: userName.toLowerCase(),
                profile_Image: null,
                name_change: "no",
                isPlaying: false,
                date_created: time
            };
            if (uploadFile) {
                var filePath = "User Profile Images/" + currentUserId + "/Images/Profile Pic";
                var storageRef = (0, _appDefault.default).storage().ref().child(filePath);
                var uploadTask = storageRef.put(uploadFile);
                uploadTask.on("state_changed", function(snapshot) {}, function(error) {
                    switch(error.code){
                        case "storage/unauthorized":
                            // User doesn't have permission to access the object
                            (0, _common.showToast)(trans.errorStoragePermission);
                            break;
                        case "storage/canceled":
                            (0, _common.showToast)(trans.errorUploadCanceled);
                            break;
                        case "storage/unknown":
                            // Unknown error occurred, inspect error.serverResponse
                            (0, _common.showToast)(trans.errorRegister);
                            break;
                    }
                    (0, _common.setDisplay)(loader, "none");
                    (0, _common.disableButton)(btnRegister1, false);
                }, function() {
                    // Handle successful uploads on complete
                    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                    uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                        //console.log('File available at', downloadURL);
                        userInfo.profile_Image = downloadURL;
                        var userRef = (0, _appDefault.default).database().ref("Users/" + currentUserId + "/info");
                        userRef.set(userInfo, function(error) {
                            if (error) {
                                //message failed
                                (0, _common.showToast)(trans.errorRegister);
                                (0, _common.setDisplay)(loader, "none");
                                (0, _common.disableButton)(btnRegister1, false);
                            } else {
                                //message sent
                                //console.log("****uploaded user info***");
                                (0, _common.setDisplay)(registerModal1, "none");
                                (0, _common.setDisplay)(loader, "none");
                                (0, _common.disableButton)(btnRegister1, false);
                                (0, _common.showToast)(trans.thankRegister);
                                getProfileInfo();
                                (0, _common.setDisplay)(registerRadio, "block");
                            }
                        });
                    });
                });
            } else {
                //console.log("id : " + currentChatId);
                var userRef = (0, _appDefault.default).database().ref("Users/" + currentUserId + "/info");
                userRef.set(userInfo, function(error) {
                    if (error) {
                        //message failed
                        (0, _common.showToast)(trans.errorRegister);
                        (0, _common.setDisplay)(loader, "none");
                        (0, _common.disableButton)(btnRegister1, false);
                    } else {
                        //message sent
                        (0, _common.setDisplay)(registerModal1, "none");
                        (0, _common.setDisplay)(loader, "none");
                        (0, _common.disableButton)(btnRegister1, false);
                        (0, _common.showToast)(trans.thankRegister);
                        getProfileInfo();
                        (0, _common.setDisplay)(registerRadio, "block");
                    }
                });
            }
        } else {
            inName1.focus();
            (0, _common.showToast)(trans.errorProvideName);
        }
    }, false);
}
function checkEmail(email) {
    (0, _appDefault.default).auth().fetchSignInMethodsForEmail(email).then(function(signInMethods) {
        if (signInMethods.indexOf((0, _appDefault.default).auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) != -1) {
            (0, _common.setDisplay)(divPassInfo, "block");
            divPassInfo.textContent = trans.welcomeBack;
            etPassword.placeholder = trans.password;
            newUser = false;
        // User can sign in with email/password.
        } else {
            (0, _common.setDisplay)(divPassInfo, "block");
            divPassInfo.textContent = trans.createPass;
            etPassword.placeholder = trans.anyPass;
            newUser = true;
        }
        (0, _common.setDisplay)(loading, "none");
    }).catch(function(error) {
        (0, _common.showToast)(error);
        (0, _common.setDisplay)(loading, "none");
    // Some error occurred, you can inspect the code: error.code
    });
}
function uploadImage(type) {
    switch(type){
        case "register":
            inImageUpload.click();
            break;
        case "logo":
            inLogoUpload.click();
            break;
        case "banner":
            inBannerUpload.click();
            break;
    }
}
jQuery.fn.shake = function(intShakes, intDistance, intDuration) {
    intShakes = intShakes || 10;
    intDistance = intDistance || 2;
    intDuration = intDuration || 1000;
    this.each(function() {
        $(this).css("position", "relative");
        for(var x = 1; x <= intShakes; x++)$(this).animate({
            left: intDistance * -1
        }, intDuration / intShakes / 4).animate({
            left: intDistance
        }, intDuration / intShakes / 2).animate({
            left: 0
        }, intDuration / intShakes / 4);
    });
    return this;
};
var language = {
    eng: {
        title: "Add Radio",
        en: "En",
        register: "You need to be logged in to register your radio station.",
        continue: "Continue with...",
        phone: "Phone",
        email: "Email",
        password: "Password",
        rememberMe: "Remember me",
        login: "LOGIN",
        infoLog: "We will use the information above to log you in or to create a new account if you do not have one.",
        disclaimer: 'By continuing, you agree to our <a href="about.html#terms">Terms and Conditions</a>, and <a href="about.html">Privacy policy</a>',
        fillInfo: 'Fill out the information below. The fields marked with an "*" are required.',
        optionalInfo: "The following information is optional. How else can your audience connect with you? (Optional)",
        uploadBanner: "Upload banner",
        uploadLogo: "Upload logo *",
        adminName: "Admin name *",
        radioName: "Radio name *",
        slogan: "slogan",
        noteSlogan: '*Example: "The Best Variety of Yesterday and Today - Sunny 99.1"',
        radioStream: "Radio stream URL *",
        noteStream: '*Example: "https://xxxx:1232"',
        anyPass: "Any password *",
        notePass: "This should not be your stream password! Provide any password to keep your radio safe",
        description: "Describe your radio *...What kind of music does your radio play, broadcast hours, etc.",
        location: "Radio location: *",
        website: "Website address",
        country: "Select country",
        next: "Next",
        errorEmail: "Please provide a valid email address",
        welcomeBack: "Welcome back! Enter the password for this account",
        createPass: "Create a password to secure your account",
        creatingAcc: "Creating account. Please wait...",
        uploadImage: "Upload Image",
        whatName: "What name would you like to use?",
        registerMe: "Register",
        name: "Name",
        thankRegister: "Thank you for registering!",
        errorRegister: "Error registering. Try again later.",
        errorPass: "Please provide a password for your account.",
        errorName: "Pleade provide the radio's administrator's name",
        errorRadioName: "Please provide the radio's name",
        errorDescription: "Please provide a description for your radio",
        errorRadioUrl: "Please provide the stream url of the radio",
        errorAdminpass: "Please provide a password to secure your radio station",
        errorLocation: "Please tells us where your radio is located",
        errorLogo: "Please upload an image of the logo on your radio",
        radioRegister: "Registering radio. Please wait...",
        congrats: "Congratulations",
        radioMessage: "Your radio station is now part of ChatMurcianys.<br>A web page was created for you to share with your audience.",
        errorStreamCopy: "This radio stream already exists in our app. Please provide a different one.",
        uploadingLogo: "Uploading logo...",
        uploadingBanner: "Uploading banner...",
        errorUnknown: "Unknown error occurred. Try again later",
        uploadingRadioInfo: "Uploading radio information, please wait...",
        errorImage: "You don't have permission to upload this image",
        errorUploadCancel: "You canceled the upload",
        downloadMess: "ChatMurcianys is available for your device on the Google PlayStore",
        download: "Descargar",
        idiom: "En",
        urlCheck: "Can you hear the radio? If not, edit the stream above",
        audioError: '*Some browsers may not reproduce your audio because it does not start with "https" <a id="aRadioLink" href="" target="_blank">click here to test audio</a>',
        errorNameCopy: "This radio name already exists in our app. Please provide a different one.",
        msgRadioVerify: 'Your application to add $name to ChatMurcianys has been received.<br>We will notify you when your radio is registered and ready to share.<br>In the meantime, you can check the status of you application by visiting "My radios" and make any changes if needed.',
        close: "Close",
        errorStoragePermission: "You don't have permission to upload this image. Upload a different image.",
        errorUploadCanceled: "The upload was canceled",
        errorProvideName: "Please provide your name"
    },
    es: {
        title: "A\xf1adir Radio",
        en: "Es",
        register: "Necesitas entrar a tu cuenta para poder registrar tu radio",
        continue: "Continua con...",
        phone: "Tel\xe9fono",
        email: "Correo Electr\xf3nico",
        password: "Contrase\xf1a",
        rememberMe: "Rec\xfaerdame",
        login: "Iniciar Sesi\xf3n",
        infoLog: "Utilizaremos la informaci\xf3n anterior para iniciar sesi\xf3n o para crear una nueva cuenta si no tiene una.",
        disclaimer: 'Al continuar, aceptas nuestros <a href="about.html#terms">T\xe9rminos y Condiciones</a>, y <a href="about.html">Pol\xedtica de Seguridad</a>',
        fillInfo: 'Completa la informaci\xf3n a continuaci\xf3n. Los campos marcados con un "*" son obligatorios.',
        optionalInfo: "La siguiente informaci\xf3n es opcional. De que otra manera puede conectarse tu audiencia contigo? (Opcional)",
        uploadBanner: "Subir banner",
        uploadLogo: "Subir logo *",
        adminName: "Nombre del due\xf1o de la radio *",
        radioName: "Nombre de la radio *",
        slogan: "slogan",
        noteSlogan: '*Ejemplo: "M\xfasica con buen gusto! - Amor 106.5"',
        radioStream: "URL de transmisi\xf3n de la radio *",
        noteStream: '*Ejemplo: "https://xxxx:1232"',
        anyPass: "Cualquier contrase\xf1a *",
        notePass: "\xa1Esto no deber\xeda ser tu contrase\xf1a de transmisi\xf3n! Proporciona cualquier contrase\xf1a para mantener tu radio segura",
        description: "Describe tu radio*...Qu\xe9 tipo de m\xfasica reproduce tu radio, horas de emisi\xf3n, etc.",
        location: "Ubicaci\xf3n de la radio: *",
        website: "Direcci\xf3n del sitio web",
        country: "Selecciona un pais",
        next: "Continuar",
        errorEmail: "Por favor provee un correo electr\xf3nico valido",
        welcomeBack: "\xa1Bienvenido de nuevo! Ingrese la contrase\xf1a para esta cuenta",
        createPass: "Crea una contrase\xf1a para proteger tu cuenta",
        creatingAcc: "Creando la cuenta. Por favor espere...",
        uploadImage: "Subir Imagen",
        whatName: "\xbfQue nombre te gustaria usar?",
        registerMe: "Registrarme",
        name: "Nombre",
        thankRegister: "\xa1Gracias por registrarte!",
        errorRegister: "Error registrandote. Int\xe9ntalo de nuevo m\xe1s tarde.",
        errorPass: "Por favor, proporciona una contrase\xf1a para tu cuenta.",
        errorName: "Por favor, indica el nombre del administrador de la radio",
        errorRadioName: "Por favor, indica el nombre de la radio",
        errorDescription: "Por favor, describe tu radio",
        errorRadioUrl: "Por favor, indica el URL de la transmisi\xf3n de radio",
        errorAdminpass: "Por favor, indica una contrase\xf1a para proteger tu estaci\xf3n de radio",
        errorLocation: "Por favor dinos d\xf3nde se encuentra tu radio",
        errorLogo: "Por favor sube una imagen del logo de tu radio",
        radioRegister: "Registrando la radio. Por favor espere ...",
        congrats: "\xa1Felicidades!",
        radioMessage: "Tu estaci\xf3n de radio ya es parte de ChatMurcianys.<br>Una p\xe1gina web ha sido creado para que puedas compartirla con tu audiencia",
        errorStreamCopy: "Esta transmisi\xf3n de radio ya existe en nuestra aplicaci\xf3n. Por favor proporciona uno diferente.",
        uploadingLogo: "Subiendo logo...",
        uploadingBanner: "Subiendo el banner...",
        errorUnknown: "Hubo un error desconocido. Intenta nuevamente m\xe1s tarde",
        uploadingRadioInfo: "Subiendo la informaci\xf3n de la radio, por favor espera",
        errorImage: "No tienes permiso de subir la imagen.",
        errorUploadCancel: "Has cancelado la carga",
        downloadMess: "ChatMurcianys est\xe1 disponible para tu dispositivo en Google PlayStore",
        download: "Descargar",
        idiom: "Es",
        urlCheck: "\xbfPuedes escuchar la radio? Si no, edita la transmisi\xf3n de arriba",
        audioError: '*Algunos navegadores tal vez no reproducir\xe1n el audio porque no comienza con "https" <a id="aRadioLink" href="" target="_blank">Haz click aqu\xed para probar el audio</a>',
        errorNameCopy: "Este nombre de radio ya existe en nuestra aplicaci\xf3n. Por favor proporciona uno diferente.",
        msgRadioVerify: 'Hemos recibido tu solicitud para agregar $name a ChatMurcianys.<br>Te notificaremos cuando tu radio est\xe9 registrada y lista para compartir.<br>Mientras tanto, puedes verificar el estado de tu solicitud visitando "Mis radios" y hacer cualquier cambio necesario.',
        close: "Cerrar",
        errorStoragePermission: "No tienes permiso de subir esta imagen. Sube una imagen diferente",
        errorUploadCanceled: "La carga fue cancelada",
        errorProvideName: "Por favor provee tu nombre"
    }
};
function translatePage(lang) {
    var translate = false;
    if (lang) {
        translate = true;
        if (lang.includes("es")) {
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            aEn.className = aEn.className.replace(" set", "");
            aEs.className += " set";
            (0, _common.setCookie)("lang", "es", 365);
        } else {
            trans = language.eng;
            document.getElementsByTagName("html")[0].setAttribute("lang", "en");
            aEs.className = aEn.className.replace(" set", "");
            aEn.className += " set";
            (0, _common.setCookie)("lang", "en", 365);
        }
    } else if ((0, _common.getCookie)("lang") != "") {
        if ((0, _common.getCookie)("lang").includes("es")) {
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            var langs = langDropdown.querySelectorAll("a");
            langs[0].className = langs[0].className.replace(" set", "");
            langs[1].className += " set";
            translate = true;
            (0, _common.setCookie)("lang", "es", 365);
        } else trans = language.eng;
    } else if (window.navigator.language && window.navigator.language.includes("es")) {
        translate = true;
        trans = language.es;
        document.getElementsByTagName("html")[0].setAttribute("lang", "es");
        aEn.className = aEn.className.replace(" set", "");
        aEs.className += " set";
    } else trans = language.eng;
    if (translate) {
        menuLang.textContent = trans.idiom;
        topHead.querySelector("h1").textContent = trans.title;
        //btnTranslate.textContent = trans.en;
        var registerPs = registerUser.querySelectorAll("p");
        registerPs[0].textContent = trans.register;
        registerPs[1].textContent = trans.continue;
        registerPs[2].textContent = trans.infoLog;
        registerPs[3].innerHTML = trans.disclaimer;
        btnPhoneLogin.textContent = trans.phone;
        btnEmailLogin.textContent = trans.email;
        etEmail.placeholder = trans.email;
        etPassword.placeholder = trans.password;
        btnLogin.textContent = trans.login;
        registerUser.querySelector(".boldText").textContent = trans.rememberMe;
        var radioPs = registerRadio.querySelectorAll("p");
        radioPs[3].textContent = trans.fillInfo;
        radioPs[4].textContent = trans.optionalInfo;
        radioPs[5].innerHTML = trans.disclaimer;
        var imgs = registerRadio.querySelectorAll(".uploadImage");
        imgs[0].textContent = trans.uploadBanner;
        imgs[1].textContent = trans.uploadLogo;
        inAdminName.placeholder = trans.adminName;
        inRadioName.placeholder = trans.radioName;
        inSlogan.placeholder = trans.slogan;
        inRadioStream.placeholder = trans.radioStream;
        inPassword.placeholder = trans.anyPass;
        var notes = registerRadio.querySelectorAll(".notes");
        notes[0].textContent = trans.noteSlogan;
        notes[1].textContent = trans.noteStream;
        notes[2].textContent = trans.notePass;
        inDescription.placeholder = trans.description;
        registerRadio.querySelector(".pickCountry label").textContent = trans.location;
        var country = countries.querySelectorAll("option");
        country[0].textContent = trans.country;
        inPhone.placeholder = trans.phone;
        inRadioEmail.placeholder = trans.email;
        inWebsite.placeholder = trans.website;
        btnAddRadio.textContent = trans.title;
        btnNext.textContent = trans.next;
        btnContinue.textContent = trans.next;
        if (newUser) divPassInfo.textContent = trans.createPass;
        else divPassInfo.textContent = trans.welcomeBack;
        loadingInfo.querySelector("p").textContent = trans.creatingAcc;
        registerModal.querySelector(".blueText").textContent = trans.whatName;
        registerModal.querySelector("span").textContent = trans.uploadImage;
        btnRegister.textContent = trans.registerMe;
        inName.placeholder = trans.name;
        loadingRadioRegister.querySelector("p").textContent = trans.radioRegister;
        modRegSuccess.querySelector("h2").textContent = trans.congrats;
        modRegSuccess.querySelector("p").innerHTML = trans.radioMessage;
        downloadApp.querySelector("#modalMessage2").textContent = trans.downloadMess;
        downloadApp.querySelector(".btnBlue").textContent = trans.download;
        divCheck.textContent = trans.urlCheck;
        registerRadio.querySelector(".notes.redText").innerHTML = trans.audioError;
        aRadioLink.href = inRadioStream.value.trim();
        $(".t-close").attr("title", trans.close);
    }
}

},{"./common":"jYzpo","firebase/compat/app":"bAwIZ","firebase/compat/auth":"hOIAn","firebase/compat/storage":"2oPDF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["5XMEC"], "5XMEC", "parcelRequire460e", {})

//# sourceMappingURL=addRadio.9f52003e.js.map
